import { library } from "@fortawesome/fontawesome-svg-core";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Header.module.scss";

library.add(faChevronLeft);

function Header(params: any) {
  const navigate = useNavigate();

  return (
    <div className={styles.Header}>
      <div className={styles.arrow} onClick={() => navigate(params.redirect, { state: params.state })}><FontAwesomeIcon icon="chevron-left" /></div>
      <div className={styles.label}>{params.name}</div>
    </div>
  );
}

export default Header;
